import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import depositService, { Deposit } from "../../services/depositService";
import { useState } from "react";
import { MenuItem } from "../../models/menu";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import Frame from "../../components/controls/Frame/Frame";
import FormModal from "../../components/controls/FormModal";
import FormCommand from "../../components/controls/FormCommand";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";

export interface DepositListingPageProps {}

export const DepositListingPage = (props: DepositListingPageProps) => {
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState<Deposit[]>();
  const [deposit, setDeposit] = useState<Deposit>();

  const contextMenuItems: MenuItem<Deposit>[] = [
    {
      name: "Edit",
      onClick: (d) => {
        setDeposit(d);
      },
    },
    {
      name: "Delete",
      onClick: (d) => {
        const ans = window.confirm(
          "Are you sure you want to delete this deposit"
        );
        if (!ans) return;

        const deleteDepositAsync = async () => {
          const res = await depositService.deleteDeposit(d.id ?? 0);
          alert(res.message);

          if (res.status) {
            setDeposits(deposits?.filter((dep) => dep.id !== d.id));
          }
        };

        deleteDepositAsync();
      },
    },
    {
      name: "Post Deposit",
      onClick: (d) => {
        const ans = window.confirm(
          "Are you sure you want to post deposit\n" +
            "Amount: " +
            d.amount?.toString() +
            ""
        );

        if (ans !== true) {
          return;
        }

        const postAsync = async () => {
          const res = await depositService.postTransaction(d.id ?? 0);
          alert(res.message);

          if (res.status) {
            d.transactionId = res.data ?? 0;
          }
        };

        postAsync();
      },
    },
    {
      name: "Reverse Deposit",
      onClick: (deposit) => {
        if (!deposit.transactionId) {
          alert("You cannot reverse a deposit that has not been posted!");
          return;
        }

        const ans = window.confirm(
          "Are you sure you want to reverse this deposit"
        );
        if (!ans) return;

        const reverseAsync = async () => {
          const res = await depositService.reverseTransaction(deposit.id ?? 0);
          alert(res.message);

          if (res.status) {
            // use the transaction id gotten to mark the response;
            console.log("Mark the deposit as reversed");
          }
        };

        reverseAsync();
      },
    },
  ];

  return (
    <Frame>
      <h4>
        Deposits <small className="text-secondary">Transactions</small>
      </h4>
      <GridView
        keys={["name"]}
        name={"lstDeposits"}
        context="Deposits"
        showSearchBar={true}
        showAddButton={true}
        rowsPerPage={50}
        onAddRecord={() => setDeposit({})}
      >
        <GridView.Header>
          <thead>
            <tr>
              <th>Account</th>
              <th>Narration</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
        </GridView.Header>
        <GridView.Content>
          {deposits?.map((d) => (
            <tr>
              <td>{d.accountName}</td>
              <td>{d.narration}</td>
              <td>{d.amount}</td>
              <td>
                <ContextMenu item={d} menu={contextMenuItems} />
              </td>
            </tr>
          ))}
        </GridView.Content>
      </GridView>

      {deposit && (
        <FormModal onClose={() => setDeposit(undefined)}>
          <DepositForm deposit={deposit} />
        </FormModal>
      )}
    </Frame>
  );
};

export type DepositFormProps = {
  deposit?: Deposit;
  onSaveDeposit?: (deposit: Deposit) => void;
};

export function DepositForm(props: DepositFormProps) {
  const [deposit, setDeposit] = useState(props.deposit);

  const saveDepositAsync = async () => {
    const res = await depositService.bookOrUpdateDeposit({
      accountId: deposit?.accountId ?? 0,
      amount: deposit?.amount ?? 0,
      narration: deposit?.narration ?? "",
      id: deposit?.id,
    });

    if (res.status && !deposit?.id) {
      props.onSaveDeposit?.(res.data as Deposit);
    }
  };

  return (
    <div className="row">
      <div className="col">
        <FindAccount text="Account" id="accountId" />

        <div className="form-group">
          <label htmlFor="narration" className="control-label">
            Narration / Description
          </label>
          <textarea
            name="narration"
            id="narration"
            className="form-control form-control-sm"
            value={deposit?.narration}
            onChange={(e) =>
              setDeposit({ ...deposit, narration: e.currentTarget.value })
            }
          ></textarea>
        </div>

        <div className="form-group">
          <label htmlFor="depositType" className="control-label">
            Deposit Type
          </label>
          <select
            id="depositType"
            name="depositType"
            className="form-control form-control-sm"
            value={deposit?.type}
            onChange={(e) =>
              setDeposit({ ...deposit, type: Number(e.currentTarget.value) })
            }
          >
            <option value={""}>Select Deposit Type</option>
            <option value={1} selected>
              Cash
            </option>
            <option value={2}>Cheque</option>
          </select>
        </div>

        <div className="row">
          <div className="col">
            <label htmlFor="amount" className="control-label">
              Amount
            </label>
            <input
              type="number"
              name="amount"
              id="amount"
              min={0}
              className="form-control form-control-sm"
              value={deposit?.amount}
              onChange={(e) =>
                setDeposit({
                  ...deposit,
                  amount: Number(e.currentTarget.value),
                })
              }
            />
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="slipNo" className="control-label">
                SlipNo
              </label>
              <input
                type="number"
                name="slipNo"
                id="slipNo"
                min={0}
                className="form-control form-control-sm"
                value={deposit?.slipNo}
                onChange={(e) =>
                  setDeposit({ ...deposit, slipNo: e.currentTarget.value })
                }
              />
            </div>
          </div>
        </div>

        <FormCommand onSubmit={() => saveDepositAsync()} />
      </div>
    </div>
  );
}
